import Search from '@components/Dashboard/SalesAttribution/SalesAttributionView/Dimensions/Search';
import { Glossary as GlossaryType } from '@features/glossary';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { ND_BLUE_DARK_2, ND_GRAY_LIGHT_2 } from '@utils/colorGenerator';
import * as React from 'react';

type GlossaryProps = {
  glossary: GlossaryType;
};

const Glossary = (props: GlossaryProps) => {
  const [searchTerm, setSearchTerm] = React.useState('');

  const onChange: React.ComponentProps<typeof Search>['onChange'] = event => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  return (
    <Grid container spacing={2} padding={2}>
      <Grid size={8}>
        <Stack spacing={2}>
          {Object.values(props.glossary)
            .toSorted((a, b) =>
              a.label
                .toLocaleLowerCase()
                .localeCompare(b.label.toLocaleLowerCase())
            )
            .filter(glossaryItem =>
              glossaryItem.label.toLowerCase().includes(searchTerm)
            )
            .map(glossaryItem => (
              <Box key={glossaryItem.label} className="glossary-pair">
                <Typography variant="h5" color={ND_BLUE_DARK_2}>
                  {glossaryItem.label}:
                </Typography>
                <Typography color={ND_GRAY_LIGHT_2}>
                  {glossaryItem.definition}
                </Typography>
                {'subItems' in glossaryItem && (
                  <Stack spacing={2} color="#818b86" paddingTop={2}>
                    {!!glossaryItem.subItems &&
                      Object.values(glossaryItem.subItems).map(subItem => (
                        <Box key={subItem.label}>
                          <Typography fontWeight="bolder" display="inline">
                            {subItem.label}:{' '}
                          </Typography>
                          <Typography display="inline">
                            {subItem.definition}
                          </Typography>
                        </Box>
                      ))}
                  </Stack>
                )}
              </Box>
            ))}
        </Stack>
      </Grid>
      <Grid size={4}>
        <Box position="sticky" top={0}>
          <Search
            onChange={onChange}
            label="Search Glossary Terms"
            placeholder="Search Glossary Terms"
            size="small"
            sx={{ marginTop: '5px', minWidth: '230px' }}
            id="glossary_search_input"
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default Glossary;
